<template>
<div id="empresas">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="domain" title="Acceso a Empresas" class="elevation-1 px-5 py-3">
                  <v-card-text>
                        <v-client-table id="lista_clientes" ref="vuetable" :data="items" :columns="columns" :options="options" class="elevation-2 pa-2">
                            <template slot="noResults">
                                <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                            </template>
                            <template slot="actions" slot-scope="props">
                                <v-btn color="primary" fab  dark  x-small title="Entrar en la Empresa" @click="acceder(props.row)">
                                    <v-icon>mdi-login-variant</v-icon>
                                </v-btn>

                            </template>
                        </v-client-table>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import moment from "moment";
export default {
    name: "DashboardDataTables",

    data: () => ({
        URL:"",
        tabla: "empresas",
        modal: false,
        usuario: "",
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home",
            },
            {
                text: "Acceso a Empresas",
                disabled: true,
                href: "",
            },
        ],

       model: {
      uuid: "",
      nombre: "",
      domicilio: {
        calle:"",
        numero_ext:"",
        numero_int:"",
        colonia:"",
        localidad:"",
        ciudad:"",
        municipio:"",
        estado:"",
        codigo_postal:"",
        referencias:""},
      contacto:{nombre:"", telefono:"", email:""},
      telefono: [],
      estatus: "",
      email: "",
      creado: {usuario:"", fecha:""},
      actualizado: [],
      impuestos: [],
      tags: [],
      tipos_precio: [],
      pagos: [],
      registro_fiscal: [],
      parametros:{clientes:true,proveedores:true,productos:true,tags:true,tipos_precio:true,impuestos:true},
    },
        rules: {},
        headers: [{
                text: "Nombre",
                value: "nombre",
            },
            {
                sortable: false,
                text: "Operaciones",
                value: "actions",
            },
        ],
        columns: [ "actions", "nombre" ],
        options: {
            filterable: ["nombre"],
            sortable: ["nombre"],

            headings: {
                nombre: "Nombre",
                actions: "Acceder"
            }
        },
        items: [],
        search: undefined,
    }),
    computed: {

    },
    methods: {
        cargar: function () {
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var params = {
                filtros: {
                    estatus:"Activo"
                },
                campos : {
                    "_id":1,
                    "nombre":1
                }
            };
            var self = this;
            this.$axios.post(this.URL + "list_empresas/", params)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.items = res.data;
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al obtener los registros.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{
                    self.$root.$dialogLoader.hide();
                });
        },

        acceder: async function (row) {
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var self = this;
            var Item = row;
            self.$local_storage.set(self.$crypto.SHA256("uuid_empresa"), self.$crypto.encrypted(Item.uuid));
            self.$local_storage.set(self.$crypto.SHA256("nombre_empresa"), self.$crypto.encrypted(Item.nombre));
            self.$store.state.instancia = self.$crypto.encrypted(Item.uuid);
            self.model = Item;


            let parametros = Item.parametros;
            self.$local_storage.set(self.$crypto.SHA256("compartir_productos"), self.$crypto.encrypted(parametros.productos?"1":"0"));
            self.$local_storage.set(self.$crypto.SHA256("compartir_clientes"), self.$crypto.encrypted(parametros.clientes?"1":"0"));
            self.$local_storage.set(self.$crypto.SHA256("compartir_proveedores"), self.$crypto.encrypted(parametros.proveedores?"1":"0"));
            self.$local_storage.set(self.$crypto.SHA256("compartir_categorias"), self.$crypto.encrypted(parametros.tags?"1":"0"));
            self.$local_storage.set(self.$crypto.SHA256("compartir_tipos_precio"), self.$crypto.encrypted(parametros.tipos_precio?"1":"0"));
            self.$local_storage.set(self.$crypto.SHA256("compartir_impuestos"), self.$crypto.encrypted(parametros.impuestos?"1":"0"));

            if (self.$local_storage.get(self.$crypto.SHA256("uuid_empresa")) != null && self.$local_storage.get(self.$crypto.SHA256("uuid_empresa")) != "") {
              var saldo = await self.$funciones.get_saldo(self.$crypto.decrypted(self.$local_storage.get(self.$crypto.SHA256("uuid_empresa"))));
              self.$local_storage.set("saldo", saldo);
              self.$store.state.instancia += saldo;
            }else {
              self.$local_storage.set("saldo", 0);
              self.$store.state.instancia += 0;
            }

            self.$router.replace("/home");

            this.$root.$dialogLoader.hide();
        },

         },
    created: function () {
        this.URL = this.$hostname + "carta_porte/administracion/";
        this.rules = this.$rules;
        this.usuario = this.$local_storage.get("usuario");
        this.cargar();
    },
};
</script>
<style >
#lista_clientes tr td:nth-child(1) {
    width: 60px !important;
}

#lista_clientes tr td:nth-child(2) {
    width: 200px !important;;
}
</style>
